module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Score")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('h4', [_vm._v("Top 50")]), _vm._v(" "), _c('ul', [(_vm.loading) ? _c('li', [_vm._v("Loading...")]) : _vm._l((_vm.leaders), function(leader, index) {
    return _c('li', [_c('span', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(leader.name) + "  - " + _vm._s(leader.score))])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-304ba2fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Score.vue
// module id = 38
// module chunks = 0